var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartOptions)?_c('VueApexChart',{ref:"chart",staticClass:"app-chart-line",class:{ 'live' : _vm.autoUpdate },attrs:{"width":"100%","height":"100%","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }